/* eslint-disable arrow-body-style */
import React from 'react'
import Image from 'next/image'
import ErrorBoundary from '@components/ErrorBoundary/errorBoundary'
import assetLoader from '@utils/internalImageLoader'
import styles from './author.module.scss'

const Author = ({ data }) => {
  const authorDisplayPicture = data?.data?.attributes?.authorPhoto?.data?.attributes?.url
  const authorData = data?.data?.attributes

  // // for id assign
  // const h2Regex = /<h2[^>]*>(.*?)<\/h2>/
  // const matches = data?.data?.attributes.name.match(h2Regex)
  // const h2Content = matches ? matches[1] : null

  return (
    <ErrorBoundary data={data}>
      <div className={`${styles.authorRootContainer} white`}>
        <div className={styles.authorContainer}>
          <div className={styles.mainAuthorWidgetSection}>
            <div className={styles.imageContainer}>
              <Image src={authorDisplayPicture} alt="Author photo Icon" width={48} height={48} loading="lazy" />
            </div>
            <div className={styles.authorMainInfo}>
              <p className={styles.authorTitle}>
                {'Written by '}
                <a href={`/author/${authorData?.username}`} target="_blank" className={styles.authorLink}>
                  {authorData?.name}
                </a>
              </p>
              <div className={styles.authorFollowersAndReviewer}>
                <p>
                  {`${authorData?.authorFollowers} Linkedin Followers`}{' '}
                  <Image
                    src={`${assetLoader()}/images/authorDot.svg`}
                    alt="Author dot Icon"
                    width={18}
                    height={18}
                    loading="lazy"
                  />
                </p>
                <p>
                  {`Reviewed by ${authorData?.reviewedBy}`}{' '}
                  <Image
                    src={`${assetLoader()}/images/authorInfo.svg`}
                    alt="Author info Icon"
                    width={20}
                    height={20}
                    loading="lazy"
                  />
                </p>
              </div>
              <p className={styles.authorBio}>{`${authorData?.authorStatement}`}</p>
            </div>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default Author
